(function () {
  "use strict";

  function initTfh(root) {
    var boxRadios = root.querySelectorAll("[data-tfh-box-option] input[type=radio]");
    var capacityLabel = root.querySelector("[data-tfh-capacity]");
    var fillStatus = root.querySelector("[data-tfh-fill-status]");
    var cards = root.querySelectorAll("[data-tfh-card]");
    var summaryCount = root.querySelector("[data-tfh-summary-count]");
    var summaryTotal = root.querySelector("[data-tfh-summary-total]");
    var addButton = root.querySelector("[data-tfh-add-to-cart]");
    var message = root.querySelector("[data-tfh-message]");

    var state = { capacity: 0, boxLabel: "Box", selections: {} };

    function currentCount() {
      var total = 0;
      Object.keys(state.selections).forEach(function (id) { total += state.selections[id].qty; });
      return total;
    }
    function currentTotalCents() {
      var total = 0;
      Object.keys(state.selections).forEach(function (id) { total += state.selections[id].qty * state.selections[id].price; });
      return total;
    }
    function formatMoney(cents) { return "R" + (cents / 100).toFixed(2); }

    function refreshUI() {
      var count = currentCount();
      if (capacityLabel) capacityLabel.textContent = state.capacity;
      if (fillStatus) { fillStatus.firstChild.textContent = count + " of "; }
      if (summaryCount) summaryCount.textContent = count + (count === 1 ? " treat" : " treats");
      if (summaryTotal) summaryTotal.textContent = formatMoney(currentTotalCents());

      cards.forEach(function (card) {
        var variantId = card.getAttribute("data-variant-id");
        var qtyEl = card.querySelector("[data-tfh-qty]");
        var incBtn = card.querySelector("[data-tfh-increase]");
        var decBtn = card.querySelector("[data-tfh-decrease]");
        var qty = (state.selections[variantId] && state.selections[variantId].qty) || 0;
        if (qtyEl) qtyEl.textContent = qty;
        card.setAttribute("data-tfh-selected", qty > 0 ? "true" : "false");
        if (decBtn) decBtn.disabled = qty <= 0;
        if (incBtn) incBtn.disabled = count >= state.capacity;
      });

      if (addButton) {
        addButton.disabled = count === 0;
        addButton.textContent = count === 0 ? "Add box to cart" : "Add " + state.boxLabel + " to cart - " + count + "/" + state.capacity;
      }
    }

    function setMessage(text, stateName) {
      if (!message) return;
      message.textContent = text || "";
      if (stateName) { message.setAttribute("data-state", stateName); } else { message.removeAttribute("data-state"); }
    }

    function applyBoxSize(radio) {
      var newCapacity = parseInt(radio.getAttribute("data-capacity"), 10) || 0;
      state.capacity = newCapacity;
      state.boxLabel = radio.getAttribute("data-box-label") || "Box";
      var count = currentCount();
      if (count > newCapacity) {
        var ids = Object.keys(state.selections);
        var idx = ids.length - 1;
        while (currentCount() > newCapacity && idx >= 0) {
          var id = ids[idx];
          if (state.selections[id] && state.selections[id].qty > 0) { state.selections[id].qty -= 1; }
          if (currentCount() <= newCapacity) break;
          idx -= 1;
          if (idx < 0) idx = ids.length - 1;
        }
        setMessage("Box size changed - we trimmed your selection to fit " + newCapacity + " treats.", "error");
      }
      refreshUI();
    }

    boxRadios.forEach(function (radio) {
      radio.addEventListener("change", function () { if (radio.checked) applyBoxSize(radio); });
      if (radio.checked) applyBoxSize(radio);
    });

    cards.forEach(function (card) {
      var variantId = card.getAttribute("data-variant-id");
      var price = parseInt(card.getAttribute("data-price"), 10) || 0;
      var incBtn = card.querySelector("[data-tfh-increase]");
      var decBtn = card.querySelector("[data-tfh-decrease]");
      if (!state.selections[variantId]) { state.selections[variantId] = { qty: 0, price: price }; }

      if (incBtn) {
        incBtn.addEventListener("click", function () {
          if (currentCount() >= state.capacity) {
            setMessage("Your " + state.boxLabel + " is full - remove a treat first or choose a bigger box.", "error");
            return;
          }
          state.selections[variantId].qty += 1;
          setMessage("");
          refreshUI();
        });
      }
      if (decBtn) {
        decBtn.addEventListener("click", function () {
          if (state.selections[variantId].qty > 0) { state.selections[variantId].qty -= 1; }
          setMessage("");
          refreshUI();
        });
      }
    });

    if (addButton) {
      addButton.addEventListener("click", function () {
        var items = [];
        Object.keys(state.selections).forEach(function (id) {
          var sel = state.selections[id];
          if (sel.qty > 0) { items.push({ id: parseInt(id, 10), quantity: sel.qty }); }
        });
        if (items.length === 0) return;

        addButton.disabled = true;
        setMessage("Adding your box to cart...");

        fetch(window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root + "cart/add.js" : "/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ items: items })
        })
          .then(function (response) {
            if (!response.ok) {
              return response.json().then(function (err) { throw new Error((err && err.description) || "Could not add to cart"); });
            }
            return response.json();
          })
          .then(function () {
            setMessage("Added your " + state.boxLabel + " to cart.", "success");
            document.dispatchEvent(new CustomEvent("cart:updated"));
            state.selections = {};
            cards.forEach(function (card) {
              var variantId = card.getAttribute("data-variant-id");
              var price = parseInt(card.getAttribute("data-price"), 10) || 0;
              state.selections[variantId] = { qty: 0, price: price };
            });
            refreshUI();
          })
          .catch(function (err) { setMessage(err.message || "Something went wrong adding your box to cart.", "error"); })
          .finally(function () { addButton.disabled = currentCount() === 0; });
      });
    }

    refreshUI();
  }

  document.querySelectorAll("[data-tfh-section]").forEach(initTfh);
})();